var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 22.991 14.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_667",
    "data-name": "\\u7EC4 667",
    transform: "translate(-1136.265 -1855.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_666",
    "data-name": "\\u7EC4 666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_298",
    "data-name": "\\u8DEF\\u5F84 298",
    d: "M1136.265,1862.385a2.89,2.89,0,0,1,.733-1.158,20.048,20.048,0,0,1,5.629-4.6,10.959,10.959,0,0,1,4.89-1.39,10.4,10.4,0,0,1,4.823,1.113,18.8,18.8,0,0,1,5.489,4.13c.365.385.718.783,1.055,1.193a1.5,1.5,0,0,1,0,1.977,21.012,21.012,0,0,1-5.749,4.914,11.165,11.165,0,0,1-4.522,1.481,9.848,9.848,0,0,1-4.526-.675,16.827,16.827,0,0,1-5.429-3.584c-.65-.617-1.241-1.294-1.864-1.94a2.288,2.288,0,0,1-.527-.92Zm16.44.273a4.949,4.949,0,1,0-4.952,4.948A4.943,4.943,0,0,0,1152.7,1862.658Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_299",
    "data-name": "\\u8DEF\\u5F84 299",
    d: "M1151.3,1862.665a3.541,3.541,0,1,1-3.532-3.55A3.551,3.551,0,0,1,1151.3,1862.665Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a4846db3bf9eea6121962f116b111714.svg";
export { ForwardRef as ReactComponent };